import { inject, Injectable, InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { ApiToken } from './model/ApiToken';
import { ApiTokensService } from './api-tokens.service';

export const COMPANY_ID_TOKEN = new InjectionToken<number>('__COMPANY_ID_TOKEN__');

@Injectable({
    providedIn: 'root'
})
export class ApiTokensResolver  {
    protected companyId = inject(COMPANY_ID_TOKEN);
    constructor(private apiTokensService: ApiTokensService) {}

    resolve(): Observable<ApiToken[]> {
        return this.apiTokensService.loadApiTokens(this.companyId).pipe(first());
    }
}
